import BaseModalForm from 'components/BaseModalForm'
import message from 'components/CustomMessage';
import Vocabulary from 'components/Vocabulary';
import { useActiveUserContext } from 'contexts/ActiveUserContext';
import _ from 'lodash';
import React, { forwardRef, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import BusinessUnitAPI from 'restAPI/BusinessUnitAPI';
import ProductAPI from 'restAPI/ProductAPI';
import { FieldTypes, parseSelectOptions } from 'utils/formUtils';

const MoveBusinessUnitFormPopup = forwardRef(function MoveBusinessUnitFormPopup({ afterClose, ...props }, ref) {
    const [businessUnits, setBusinessUnit] = useState(null);
    const activeUser = useActiveUserContext();
    const editededRef = useRef(false);

    useEffect(() => {
        const { promise, cancel } = BusinessUnitAPI.getAll();
        promise
            .then((data) => setBusinessUnit(_.filter(data, (d)=>d.name !== activeUser.businessUnitsName)))
            .catch(() => {
                setBusinessUnit([]);
            });
        return cancel;
    }, [props.productId, activeUser.businessUnitsName]);

    const fields = useMemo(() => {
        return [{
            name: "message",
            render: () => <p>This will move the <Vocabulary name="product" /> along with its data to the selected Organization. This may take a few minutes.</p>
        },{
            name: "currentProduct",
            label: <>Current Organization</>,
            render: () => activeUser.businessUnitsName
        }, {
            name: "businessUnit",
            label: "Organization",
            type: FieldTypes.SELECT,
            help: <>Select a Organization to move to</>,
            required: true,
            options: parseSelectOptions(businessUnits)
        }]
    }, [activeUser.businessUnitsName, businessUnits]);

    const onSubmit = useCallback(async (values) => {
        await ProductAPI.moveToAnotherBusinessUnit(props.productId, values.businessUnit).promise;
        editededRef.current = true;
        message.success(<>Move <Vocabulary name="product" />: {props.productName} initiated, please check after some time.</>)
    }, [props.productId, props.productName]);

    return (
        <BaseModalForm
            fields={fields}
            onOk={onSubmit}
            title={<>Move <Vocabulary name={"product"} />: {props.productName} </>}
            ref={ref}
            afterClose={() => afterClose(editededRef.current)}
            {...props}
        />
    )
})

export default MoveBusinessUnitFormPopup;
